import createIcon from '../../createIcon';

/**
 * @component @name StarBorder
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgOS43NEwxNC44MSA5LjEyTDEyIDIuNUw5LjE5IDkuMTNMMiA5Ljc0TDcuNDYgMTQuNDdMNS44MiAyMS41TDEyIDE3Ljc3TDE4LjE4IDIxLjVMMTYuNTUgMTQuNDdMMjIgOS43NFpNMTIgMTUuOUw4LjI0IDE4LjE3TDkuMjQgMTMuODlMNS45MiAxMS4wMUwxMC4zIDEwLjYzTDEyIDYuNkwxMy43MSAxMC42NEwxOC4wOSAxMS4wMkwxNC43NyAxMy45TDE1Ljc3IDE4LjE4TDEyIDE1LjlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const StarBorder = createIcon('StarBorder', [
  [
    'path',
    {
      d: 'M22 9.74L14.81 9.12L12 2.5L9.19 9.13L2 9.74L7.46 14.47L5.82 21.5L12 17.77L18.18 21.5L16.55 14.47L22 9.74ZM12 15.9L8.24 18.17L9.24 13.89L5.92 11.01L10.3 10.63L12 6.6L13.71 10.64L18.09 11.02L14.77 13.9L15.77 18.18L12 15.9Z',
      key: '1ikdht',
    },
  ],
]);

export default StarBorder;
